import apiClient from '@/services/axios'

export async function get(membershipId) {
  var response = await apiClient.get('/memberships/' + membershipId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get Membership.')
}
